var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-wrapper",
    {
      staticClass: "third-opportunities-form",
      attrs: {
        linkedForm: _vm.linkedForm,
        redirection: _vm.redirectionTo,
        store: _vm.store,
        current: _vm.current,
        deletionConfirmation: _vm.hasItemCreated,
        labelSaveAndAction: _vm.saveAndLabelAction
      },
      on: { "catch-errors": _vm.catchErrors }
    },
    [
      _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.formTitle))]),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "opportunity",
            toggleAllowed: false,
            title: _vm.$t.__("pages.forms.ThirdOpportunitiesForm.opportunity")
          }
        },
        [
          _c("form-fields-opportunity", {
            ref: "main",
            attrs: { currentStore: _vm.current, error: _vm.error.errors }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: _vm.relatedThird,
            toggleAllowed: false,
            title: _vm.relatedThirdTitle[_vm.relatedThird],
            switchAllowed: ""
          },
          on: {
            "switch-form-field": function($event) {
              return _vm.switchFomField()
            }
          }
        },
        [
          _c("form-fields-third-to-add", {
            ref: "formFieldsThirdToAdd",
            attrs: {
              currentStore: _vm.current,
              lightForm: "",
              third: _vm.relatedThird
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.relatedThird === "company"
        ? _c(
            "form-fields-wrapper",
            {
              attrs: {
                field: "contact",
                activeFields: ["contact"],
                toggleAllowed: true,
                title: _vm.$t.__("common.labels.contact")
              }
            },
            [
              _c("form-fields-contact-to-add", {
                attrs: {
                  disabled: !_vm.hasCompany,
                  goBackMsg: _vm.goBackMsg,
                  currentStore: _vm.current,
                  addToListWording: _vm.addToContactListWording,
                  lightForm: "",
                  mode: "manual"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "custom-fields",
            toggleAllowed: true,
            activeFields: ["custom-fields"],
            title: _vm.$t.__(
              "pages.forms.ThirdOpportunitiesForm.opportunity_custom_fields"
            )
          }
        },
        [
          _c("form-fields-custom-fields", {
            ref: "custom-fields",
            attrs: {
              currentStore: _vm.current,
              error: _vm.error.errors,
              currentCustomfields: _vm.getCustomFields
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }